import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import { initAxios } from "@/api/api";

import VueToast from "vue-toast-notification";
import "vue-toast-notification/dist/theme-sugar.css";
import $ from "jquery";
import axios from "axios";
import VueAxios from "vue-axios";
import VueSweetalert2 from "vue-sweetalert2";
import { BootstrapVue } from "bootstrap-vue";
import "bootstrap/dist/css/bootstrap.css";
// import "bootstrap-vue/dist/bootstrap-vue.css";
import ConfirmationService from "primevue/confirmationservice";
import PrimeVue from "primevue/config";

Vue.use(PrimeVue, {
  ripple: true,
  locale: {
    closeText: "Fermer",
    prevText: "Précédent",
    nextText: "Suivant",
    monthNames: [
      "Janvier",
      "Février",
      "Mars",
      "Avril",
      "Mai",
      "Juin",
      "Juillet",
      "Août",
      "Septembre",
      "Octobre",
      "Novembre",
      "Décembre",
    ],
    monthNamesShort: [
      "Jan",
      "Fév",
      "Mar",
      "Avr",
      "Mai",
      "Jun",
      "Jul",
      "Aoû",
      "Sep",
      "Oct",
      "Nov",
      "Déc",
    ],
    dayNames: [
      "Dimanche",
      "Lundi",
      "Mardi",
      "Mercredi",
      "Jeudi",
      "Vendredi",
      "Samedi",
    ],
    dayNamesShort: ["Dim", "Lun", "Mar", "Mer", "Jeu", "Ven", "Sam"],
    dayNamesMin: ["D", "L", "M", "M", "J", "V", "S"],
    weekHeader: "Semaine",
    firstDay: 1,
    dateFormat: "mm/dd/yy",
    isRTL: false,
    showMonthAfterYear: false,
    yearSuffix: "",
    timeOnlyTitle: "Choisir l'heure",
    timeText: "Heure",
    hourText: "Heures",
    minuteText: "Minutes",
    secondText: "Secondes",
    currentText: "Maintenant",
    ampm: false,
    month: "Mois",
    week: "Semaine",
    day: "Jour",
    allDayText: "Toute la journée",
    accept: "Oui",
    reject: "Non",
  },
});
import "primevue/resources/themes/bootstrap4-light-blue/theme.css";
import "primevue/resources/primevue.min.css";
import "primeicons/primeicons.css";
import Tag from "primevue/tag";
import { IconsPlugin } from "bootstrap-vue";
import { Datetime } from "vue-datetime";
import "vue-datetime/dist/vue-datetime.css";
// You need a specific loader for CSS files
import Calendar from "primevue/calendar";
import ProgressBar from "primevue/progressbar";
import ImagePreview from "primevue/imagepreview";
import TabMenu from "primevue/tabmenu";
import Checkbox from "primevue/checkbox";
import InputSwitch from "primevue/inputswitch";
import Slider from "primevue/slider";
import InputText from "primevue/inputtext";
import PMultiSelect from 'primevue/multiselect';
import MultiSelect from 'vue-multiselect'
import Skeleton from "primevue/skeleton";
import DataTable from "primevue/datatable";
import Column from "primevue/column";
import ColumnGroup from "primevue/columngroup";
import BlockUI from "primevue/blockui";
import Tooltip from "primevue/tooltip";
import Dropdown from "primevue/dropdown";
import TabView from "primevue/tabview";
import TabPanel from "primevue/tabpanel";
import Button from "primevue/button";
import ColorPicker from "primevue/colorpicker";
import Textarea from "primevue/textarea";
import VueLoading from 'vuejs-loading-plugin';
import Chart from 'primevue/chart';


import VuePhoneNumberInput from 'vue-phone-number-input';
import 'vue-phone-number-input/dist/vue-phone-number-input.css';

import { BTable } from "bootstrap-vue";
import { TablePlugin } from "bootstrap-vue";

// import UploadImage from 'vue-upload-image';
//  import swal from "sweetalert2/dist/sweetalert2.js";
//  import "sweetalert2/src/sweetalert2.scss";
// Import Bootstrap and BootstrapVue CSS files (order is important)
//  import "bootstrap/dist/css/bootstrap.css";
//  import "bootstrap-vue/dist/bootstrap-vue.css";

Vue.use(ConfirmationService);
Vue.component("PTag", Tag);

global.$ = $;
global.jQuery = $;
Vue.use(TablePlugin);
Vue.component("b-table", BTable);
Vue.component("ColorPicker", ColorPicker);
Vue.component("Button", Button);
Vue.component("Textarea", Textarea);
Vue.component("TabView", TabView);
Vue.component("TabPanel", TabPanel);
Vue.component("BlockUI", BlockUI);
Vue.component("DataTable", DataTable);
Vue.component("Column", Column);
Vue.component("ColumnGroup", ColumnGroup);
Vue.component("PCalendar", Calendar);
Vue.component("ProgressBar", ProgressBar);
Vue.component("ImagePreview", ImagePreview);
Vue.component("TabMenu", TabMenu);
Vue.component("Checkbox", Checkbox);
Vue.component("InputSwitch", InputSwitch);
Vue.component("Slider", Slider);
Vue.component("InputText", InputText);
Vue.component('PMultiSelect', PMultiSelect);
Vue.component('MultiSelect', MultiSelect);
Vue.component("Skeleton", Skeleton);
Vue.directive("tooltip", Tooltip);
Vue.component("Dropdown", Dropdown);
Vue.component('vue-phone-number-input', VuePhoneNumberInput);
Vue.component('Chart', Chart);

Vue.config.devtools = false;

Vue.use(VueSweetalert2);
Vue.use(BootstrapVue);
Vue.use(IconsPlugin);
Vue.use(TablePlugin);
initAxios(); // Initialize axios
Vue.use(VueToast);
Vue.use(VueAxios, axios);
const moment = require("moment");

require("moment/locale/fr");
Vue.use(Datetime);
Vue.use(require("vue-moment"), {
  moment,
});
Vue.use(VueLoading, {
  dark: true,
  text: 'Un instant . . .',
})


// Vue.use(BootstrapVue)
// Vue.component('FileUpload', FileUpload);
// register globally
// Vue.component('upload-image', UploadImage)
// Vue.component("datepicker", Datepicker);
// Vue.component("timepicker", Timepicker);
// Vue.component("datetime-picker", DatetimePicker);
// Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount("#app");
